var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5011_1730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.437866 6.01311C0.437866 4.39692 0.978422 3.06359 2.05949 2.01312C3.14055 0.962598 4.54599 0.437363 6.2757 0.437363C7.97456 0.437363 9.34905 0.954501 10.3993 1.98888C11.4803 3.05554 12.0209 4.4454 12.0209 6.15857C12.0209 7.71008 11.4958 9.00297 10.4456 10.0373C9.36452 11.104 7.94366 11.6373 6.18304 11.6373H6.13671C4.43785 11.6373 3.06336 11.104 2.01316 10.0373C0.962947 8.97068 0.437866 7.62925 0.437866 6.01311ZM1.04018 48.4373V16.0495H11.3259V48.4373H1.04018ZM17.0247 48.4373H27.3105V30.3525C27.3105 29.2211 27.434 28.3484 27.6811 27.7343C28.1135 26.6353 28.7699 25.706 29.6502 24.9464C30.5305 24.1868 31.6348 23.807 32.963 23.807C36.4224 23.807 38.1522 26.2474 38.1522 31.1282V48.4373H48.4379V29.8676C48.4379 25.0838 47.3568 21.4555 45.1946 18.9828C43.0324 16.5101 40.1753 15.2737 36.6232 15.2737C32.6386 15.2737 29.5344 17.0676 27.3105 20.6555V20.7525H27.2641L27.3105 20.6555V16.0495H17.0247C17.0865 17.0838 17.1174 20.2999 17.1174 25.6979C17.1174 31.0959 17.0865 38.6757 17.0247 48.4373Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5011_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "currentColor",
    transform: "translate(0.437866 0.437912)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.b4e5d1245eb4dc792df34669c7166183.svg";
export { ForwardRef as ReactComponent };